<template>
    <div class="travelDetail">
        <home-nav-trip></home-nav-trip>
        <div class="charter-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/travel' }">旅游出行</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/tourism' }">境外旅游</el-breadcrumb-item>
                <el-breadcrumb-item>确认订单</el-breadcrumb-item>
                <el-breadcrumb-item>
                    支付
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="sureOrder">
            <div class="sureOrderTop">
                <div class="sureOrderTopTit">
                    <p>订单提交成功，应付金额：</p>
                    <span>￥{{ moneyAll }}</span>
                </div>

                <div class="sureOrderTopTitOrder">
                    <p>订单编号：{{ order_num }}</p>
                    <span>购买产品：旅游出行</span>
                </div>
            </div>

            <div class="orderType">
                <span class="orderTypeTit">
                  支付方式
                </span>

                <div class="orderChange">
                    <el-radio-group class="orderChangeGroup" v-model="radio" @change="agreeChange">
                        <el-radio class="orderChangeRadio" :class="radio == 1 ? 'borderAc' : ''" :label="1">
                            <div class="payWX">
                                <img src="@/assets/images/tourism/weixinpay.png">
                                <span>微信支付</span>
                            </div>
                        </el-radio>
                        <el-radio class="orderChangeRadio" :class="radio == 2 ? 'borderAc' : ''" v-model="radio" :label="2">
                            <div class="payZFB">
                                <img src="@/assets/images/tourism/zhifubaopay.png">
                                <span>支付宝支付</span>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div class="orderType">
                <span class="orderTypeTit">
                  {{ radio == 1 ? '微信' : '支付宝'  }}扫码
                </span>

                <div class="codePay">
                    <div class="codePayBox" id="qrcode" ref="qrcode">

                    </div>
                </div>
            </div>
        </div>
        <!--底部-->
        <home-footer></home-footer>
    </div>
</template>

<script>
    import homeNavTrip from '@/components/homeNavTrip';
    import homeFooter from '@/components/homeFooter';
    import QRCode from 'qrcodejs2';

    export default {
        name: "PlaceOrder",
        components: {
            homeNavTrip,
            homeFooter,
            QRCode
        },
        created() {

        },
        mounted() {
            this.order_id = this.$route.params.o_id;
            if(this.order_id != '' && this.order_id != undefined) {
                this.getCode();
                this.getOrderInfo();
            }
            // 初始化websocket
            this.initWebsocket()
        },
        data() {
            return {
                radio: 1,
                moneyAll: 0.00,
                order_id:'',
                order_num:'',
                path:"ws://47.104.215.79:2346",
                socket:""
            }
        },
        methods: {
            getCode(){
                var that = this;
                var currentSelectType = that.radio;
                var payWay;
                var codeUrl;
                if (currentSelectType == 1) {
                    payWay = 'wx';
                } else if (currentSelectType == 2) {
                    payWay = 'zfb';
                }

                const loading = this.$loading({
                    lock: true,
                    text: '数据加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                if(payWay == 'wx'){
                    that.$axios.post('https://vvv.baostart.com/api/wxqrcode',{
                      order_id: that.order_id,
                    }).then((res) => {
                        loading.close();
                        res = res.data;
                        console.log(res);
                        if(res.status == 200){
                            codeUrl = res.data.code_url;
                            that.qrcodeScan(codeUrl);
                          // setInterval(function () {
                          //   that.checkPayStatus(orderId); //定时轮询任务
                          // }, 2000);
                        } else {
                            loading.close();
                            this.$message('订单状态异常');
                        }
                    }).catch((error) => {
                        loading.close();
                        // console.log(error);
                    });
                } else if(payWay == 'zfb'){
                    that.$axios.post('https://vvv.baostart.com/api/PcAliPay',{
                      order_id: that.order_id,
                    }).then((res) => {
                        loading.close();
                        res = res.data;
                        // console.log(res);
                        if(res.status == 200){
                            codeUrl = res.data.qr_code;
                            that.qrcodeScan(codeUrl);
                            // setInterval(function () {
                            //   that.checkPayStatus(orderId); //定时轮询任务
                            // }, 2000);
                        } else {
                            loading.close();
                            this.$message('订单状态异常');
                        }
                    }).catch((error) => {
                        loading.close();
                        // console.log(error);
                    });
                }
            },
            //生成二维码
            qrcodeScan (qrcodeUrl) {
                // console.log(qrcodeUrl);
                this.$refs.qrcode.innerHTML = ''
                let qrcode = {};
                qrcode = new QRCode('qrcode', {
                    width: 104,  // 二维码宽度
                    height: 104, // 二维码高度
                    text: qrcodeUrl
                })
            },

            agreeChange(val){

                let that = this;
                // console.log(val);
                that.radio = val;
                that.getCode();
            },

            /*获取订单信息*/
            getOrderInfo() {
                var that = this;
                that.$axios.post('/getTravelOrderInfo', {
                    order_id:this.order_id,
                }).then((res) => {
                  res = res.data;
                  // console.log(res);return;
                  if(res.status == 200){
                      that.moneyAll = res.data.paymoney;
                      that.order_num = res.data.order_num;
                  } else {
                      // console.log(res);
                      this.$message(res.message);
                  }
                }).catch((error) => {
                    this.$message('系统错误');
                });
            },

            initWebsocket() {
                if(typeof(WebSocket) === "undefined"){
                    alert("您的浏览器不支持socket")
                }else{
                    // 实例化socket
                this.socket = new WebSocket(this.path)
                    // 监听socket连接
                this.socket.onopen = this.open
                    // 监听socket错误信息
                this.socket.onerror = this.error
                    // 监听socket消息
                this.socket.onmessage = this.getMessage
              }
            },
            open: function () {
                // console.log("socket连接成功")
            },
            error: function () {
                console.log("连接错误")
            },
            getMessage: function (msg) {
                var that = this;
                // console.log('收到消息...');
                var msgData = JSON.parse(msg.data);
                // console.log(msgData)

                if(msgData.type == "loginT") {
                    that.$axios.post('/bandWebsocket', {
                        sid:msgData.client_id,
                    }).then((res) => {

                    if(res.status == 200){

                    } else {
                        // console.log(res);
                        this.$message(res.message);
                    }
                    }).catch((error) => {
                        this.$message('系统错误');
                    });
                }else if(msgData.type == "paysuccess"){
                    console.log('支付成功，正在跳转！');
                    this.$message('支付成功，正在跳转！');
                }
            },
            send: function () {
                this.socket.send(params)
            },
            close: function () {
                console.log("socket已经关闭")
            }

        },

        watch: {
            moneyAll(newVal, oldVal) {
                var that = this;
                var money = that.moneyAll;
                if (money != '') {
                    // this.colorChange = true;
                } else {
                    // this.colorChange = false;
                }
            }
        }
    }
</script>

<style scoped>
    @import './placeOrder.css';
</style>



// WEBPACK FOOTER //
// src/pages/placeOrder/placeOrder.vue